/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
     ========================================================================== */

/**
   * Remove the margin in all browsers.
   */

body {
  margin: 0;
}

/**
   * Render the `main` element consistently in IE.
   */

main {
  display: block;
}

/**
   * Correct the font size and margin on `h1` elements within `section` and
   * `article` contexts in Chrome, Firefox, and Safari.
   */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
     ========================================================================== */

/**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
     ========================================================================== */

/**
   * Remove the gray background on active links in IE 10.
   */

a {
  background-color: transparent;
}

/**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */

b,
strong {
  font-weight: bolder;
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
   * Add the correct font size in all browsers.
   */

small {
  font-size: 80%;
}

/**
   * Prevent `sub` and `sup` elements from affecting the line height in
   * all browsers.
   */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
     ========================================================================== */

/**
   * Remove the border on images inside links in IE 10.
   */

img {
  border-style: none;
}

/* Forms
     ========================================================================== */

/**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */

button,
input {
  /* 1 */
  overflow: visible;
}

/**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */

button,
select {
  /* 1 */
  text-transform: none;
}

/**
   * Correct the inability to style clickable types in iOS and Safari.
   */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
   * Remove the inner border and padding in Firefox.
   */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
   * Restore the focus styles unset by the previous rule.
   */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
   * Correct the padding in Firefox.
   */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from `fieldset` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    `fieldset` elements in all browsers.
   */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */

progress {
  vertical-align: baseline;
}

/**
   * Remove the default vertical scrollbar in IE 10+.
   */

textarea {
  overflow: auto;
}

/**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
   * Remove the inner padding in Chrome and Safari on macOS.
   */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to `inherit` in Safari.
   */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
     ========================================================================== */

/*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */

details {
  display: block;
}

/*
   * Add the correct display in all browsers.
   */

summary {
  display: list-item;
}

/* Misc
     ========================================================================== */

/**
   * Add the correct display in IE 10+.
   */

template {
  display: none;
}

/**
   * Add the correct display in IE 10.
   */

[hidden] {
  display: none;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: inherit;
  vertical-align: baseline;
}


:host {
  /**
   * @prop --circular-diameter: Diameter of the circular-indicator in px, rem or %
   */

  display: block;

  --linear-border-radius: 0.25rem;
  --inner-color: var(--ic-loading-indicator-inner-color);
  --outer-color: var(--ic-loading-indicator-outer-color);
  --label-color: var(--ic-loading-indicator-label-color);
  --margin: none;
  --linear-line-height: var(--ic-space-xs);
}

:host(.ic-loading-indicator-monochrome) {
  --inner-color: var(--ic-loading-indicator-inner-color-monochrome);
  --outer-color: var(--ic-loading-indicator-outer-color-monochrome);
  --label-color: var(--ic-loading-indicator-label-color-monochrome);
}

.ic-loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:host(.ic-loading-indicator-size-small) {
  --circular-diameter: 2.5rem;
  --linear-line-height: var(--ic-space-xxs);
}

:host(.ic-loading-indicator-size-medium) {
  --circular-diameter: 5rem;
}

:host(.ic-loading-indicator-size-large) {
  --circular-diameter: 7.5rem;
}

:host(.ic-loading-indicator-size-icon) {
  display: inline-block;

  --margin: var(--ic-space-xxxs);
  --circular-diameter: 1.25rem;
}

:host(.ic-loading-indicator-label) {
  --margin: 0 0 var(--ic-space-xs) 0;
}

.ic-loading-label {
  --ic-typography-color: var(--label-color);

  margin-left: var(--label-margin-left);
}

.ic-loading-circular-outer {
  height: var(--circular-diameter);
  width: var(--circular-diameter);
}

.ic-loading-circular-outer.indeterminate {
  animation: circular-animation 1s linear;
  animation-iteration-count: infinite;
}

@keyframes circular-animation {
  100% {
    transform: rotate(360deg);
  }
}

.ic-loading-circular-outer,
.ic-loading-linear-outer {
  margin: var(--margin);
}

.ic-loading-linear-outer {
  background-color: var(--outer-color);
  height: var(--linear-line-height);
  width: 100%;
  border-radius: var(--linear-border-radius);
  overflow: hidden;
}

.ic-loading-circular-outer[aria-valuenow="0"] .ic-loading-circular-inner,
.ic-loading-linear-outer[aria-valuenow="0"] .ic-loading-linear-inner {
  --inner-color: var(--outer-color);
}

.ic-loading-linear-inner {
  position: relative;
  height: 100%;
  background-color: var(--inner-color);
  border-radius: var(--linear-border-radius);
}

.indeterminate > .ic-loading-linear-inner {
  animation: linear-animation 2s infinite;
}

.determinate > .ic-loading-linear-inner {
  transition: width 0.5s;
  width: var(--linear-width);
}

:host(.ic-loading-indicator-full-width) {
  --linear-border-radius: none;
}

@keyframes linear-animation {
  0% {
    width: 0%;
    left: -1%;
  }

  25% {
    width: 0%;
    left: -1%;
  }

  50% {
    width: 101%;
    left: -1%;
  }

  75% {
    width: 0%;
    left: 101%;
  }

  100% {
    width: 0%;
    left: 101%;
  }
}

.ic-loading-circular-svg {
  position: relative;
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.ic-loading-circular-svg circle {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: var(--compact-step-outer-color, var(--outer-color));
  stroke-width: var(--circular-line-width);
  stroke-linecap: round;
}

/* --stroke-dash-array calculated via dashArray method */
.ic-loading-circular-svg circle:nth-child(2) {
  --circular-indeterminate: calc(
    (0.25 * var(--stroke-dasharray)) - var(--stroke-dasharray)
  );

  stroke-dasharray: var(--stroke-dasharray), var(--stroke-dasharray);
  stroke-dashoffset: var(--stroke-dashoffset, var(--circular-indeterminate));
  stroke: var(--compact-step-inner-color, var(--inner-color));
}

.inner-label {
  height: 100%;
  display: grid;
}

.inner-label .ic-loading-circular-svg,
.inner-text {
  grid-column: 1;
  grid-row: 1;
}

/** ic-stepper **/
:host(.not-required.compact-step-progress-indicator)
  .ic-loading-circular-svg
  circle:nth-child(2) {
  stroke: var(--ic-architectural-300);
}

.inner-text {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--ic-space-lg);
  height: inherit;
  overflow: hidden;
  margin: auto;

  --ic-typography-color: var(
    --ic-step-indicator-text-current,
    var(--ic-status-info-default)
  );
}

:host(.not-required.compact-step-progress-indicator) .inner-text {
  --ic-typography-color: var(--ic-step-indicator-text-disabled);
}

:host(.ic-loading-indicator-light.not-required.compact-step-progress-indicator)
  .inner-text {
  --ic-typography-color: var(--ic-architectural-400);
}

/** High Contrast **/
@media (forced-colors: active) {
  .indeterminate > .ic-loading-circular-inner {
    forced-color-adjust: none;
  }

  .ic-loading-linear-outer {
    border: var(--ic-border-hc);
  }

  .ic-loading-linear-inner {
    background-color: canvastext;
  }

  .ic-loading-circular-svg circle {
    stroke: Background;
  }

  .ic-loading-circular-svg circle:nth-child(2) {
    stroke: canvastext;
  }

  :host(.not-required.compact-step-progress-indicator)
    .ic-loading-circular-svg
    circle:nth-child(2) {
    stroke: GrayText;
  }
}
